// sqs.service.ts

import {Injectable} from '@angular/core';
import {BrowserAgent} from '@newrelic/browser-agent/loaders/browser-agent';
import {SettingsService} from 'app/common/settings.service';
import {ENABLE_ACTION_LOGGING} from 'app/constants/setting';

@Injectable({
    providedIn: 'root'
})
export class LogService {
    tenant: any;
    userId: any;
    role: any;
    authority: any;
    name: any;
    email: any;
    tabId: any;
    actionLoggingEnabled: boolean;

    constructor(
        private settingsService: SettingsService,
        private newrelicAgent?: BrowserAgent
    ) {
        this.settingsService.subscribeToSetting(ENABLE_ACTION_LOGGING, (value) => {
            this.actionLoggingEnabled = !!value;
        });
    }

    log(action: any, metadata: any): void {
        if (!this.actionLoggingEnabled) {
            return;
        }
        try {
            this.newrelicAgent?.addPageAction(action, {
                ...metadata
            });
        } catch (error) {
            console.error(error);
        }
    }

    logDirect(action: any, metadata: any): void {
        try {
            this.newrelicAgent?.addPageAction(action, {
                ...metadata
            });
        } catch (error) {
            console.error(error);
        }
    }
}
